module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fVac4"))).then(() => module.bundle.root('lKlEc'));